import { render, staticRenderFns } from "./scope38.vue?vue&type=template&id=5da28232&scoped=true"
import script from "./scope38.vue?vue&type=script&lang=js"
export * from "./scope38.vue?vue&type=script&lang=js"
import style0 from "./scope38.vue?vue&type=style&index=0&id=5da28232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da28232",
  null
  
)

export default component.exports